import { initialState, State, Action } from '../store/store';

export const loadSuspendData = (
  state: State = initialState,
  { data }: Action
): State => {
  console.log('loadSuspendData :', data);

  // we're gonna park this for the moment
  //
  const hasSavedAssessments =
    data?.assessments && Object.keys(data.assessments).length;

  let { interactionsLocked, landingPagesSeenState } = data;
  if (interactionsLocked === undefined || interactionsLocked?.length === 0) {
    interactionsLocked = state.interactionsLocked;
  }

  const { moduleVariables = {}, location = '' } = data;

  const newState = {
    ...state,
    ...{
      interactionsSeen: data.interactionsSeen,
      //
      interactionsLocked,
      landingPagesSeenState,
      //
      userBehaviour: {
        ...state.userBehaviour,
        ...{
          score: data.score,
          interactionsReporting: data.interactionsReporting,
        },
      },
      ...(hasSavedAssessments && { assessments: data.assessments }),
      //
      moduleVariables,
      location,
    },
  };

  return newState;
};
